import { render, staticRenderFns } from "./ShowCompanytwo.vue?vue&type=template&id=e369ff22&scoped=true&"
import script from "./ShowCompanytwo.vue?vue&type=script&lang=js&"
export * from "./ShowCompanytwo.vue?vue&type=script&lang=js&"
import style0 from "./ShowCompanytwo.vue?vue&type=style&index=0&id=e369ff22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e369ff22",
  null
  
)

export default component.exports